






























































import ApiSearchPage from "@/components/apiSearch/components/ApiSearchPage.vue";
import IconButton from "@/components/IconButton.vue";
import Tooltip from "@/components/Tooltip.vue";

import Vue from "vue";
import { DownPayment } from "../models";
import store, { DownPaymentStore } from "../services/store";
import { ApiSearchColumn, ColumnType } from "@/components/apiSearch/models/ApiSearch";
import StatusChip from "@/components/StatusChip.vue";
import { t } from "@/plugins/i18n";

interface Data {
  store: DownPaymentStore;
}

export default Vue.extend({
  components: { ApiSearchPage, IconButton, Tooltip, StatusChip },

  data: (): Data => ({
    store,
  }),

  async beforeMount() {
    this.store.downPaymentList.items = [];
    /* await this.store.loadDownPayments(); */
  },

  methods: {
    create() {
      this.$router.push(`/down-payment/search`);
    },

    editItem(item: DownPayment) {
      this.$router.push(`/down-payment/edit/${item.id}`);
    },
  },

  computed: {
    columns: (): ApiSearchColumn[] => [
      {
        field: "ID",
        title: t("Azonosito"),
        cell: "id",
      },
      { field: "invoiceNo", title: t("BizonylatSzam") },
      { field: "partnerName", title: t("Szallito") },
      {
        field: "invoiceDate",
        title: t("SzamlaDatuma_2"),
        type: ColumnType.Date,
      },
      {
        field: "payTerm",
        title: t("FizetesiHatarido"),
        type: ColumnType.Date,
      },
      {
        field: "netto",
        title: t("Netto"),
        type: ColumnType.Money,
      },
      { field: "currency", title: t("Penznem") },
      {
        field: "permitStatus",
        title: t("DownPayment_UtalvanyozasStatusz"),
        cell: "permitStatus",
        type: ColumnType.Center,
      },
      {
        field: "preStatus",
        title: t("Allapot"),
        cell: "preStatus",
        type: ColumnType.Center,
      },
      { cell: "command", sortable: false, filterable: false },
    ],
  },
});
